import { forwardRef } from 'react';
import { StyledAccordionBody } from './styled';
import { useAccordionItemContext } from '../../../contexts/accordion';

const AccordionBody = forwardRef((props, ref) => {
  const { isOpen, bodyProps } = useAccordionItemContext();

  return <StyledAccordionBody ref={ref} {...bodyProps(props)} />;
});

export default AccordionBody;
